export const baseRoutes = {
  admin: {
    dashboard: '/admin',
    users: {
      list: '/admin/users',
      new: '/admin/users/new',
      edit: '/admin/users/:id',
    },
    translations: {
      list: '/admin/translations',
    },
    profile: '/admin/profile',
    profileSettings: '/admin/profile?activeTab=2',
    company: '/admin/company',
    settings: '/admin/settings',
    companies: {
      list: '/admin/companies',
      new: '/admin/companies/new',
      edit: '/admin/companies/:id',
    },
  },
  auth: {
    login: '/login',
    registrationConfirmation: '/registration-confirmation/:token',
    deletionConfirmation: '/deletion-confirmation/:token',
    passwordReset: '/password-reset',
    passwordResetConfirmation: '/password-reset/:token',
  },
  homepage: '/',
};
